import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';




@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router){}


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      try{
        let user = JSON.parse( localStorage.getItem("user") );
        if(!user.token){
            throw Error("No session...");
        }
      }
      catch(e){
        this.router.navigate(['/login']);
        return false;
      }
    return true;
  }

  getTokenHeader() : HttpHeaders{
    return new HttpHeaders({ 'X-Auth-Token' :localStorage.getItem('X-Auth-Token') });
  }

}